import axios from '_u/axios'

// 水电充值列表
export const orderRechargeList = (body) => {
    return axios.post('api/order/recharge/list', body)
}

// 水电充值记录
export const orderRechargeHistory = (body) => {
    return axios.post('api/order/recharge/history', body)
}

// 房间-扣费记录
export const orderDeductionList = (body) => {
    return axios.post('api/order/deduction/list', body)
}

// 扣费记录列表
export const orderDeductionListAll = (body) => {
    return axios.post('api/order/deduction/deductionList', body)
}

// 房间-绑定表关系
export const iotSmartmeterHouse = (body) => {
    return axios.post('api/iot/smartmeter/houseMeterBind', body)
}

// 设备读数记录
export const iotSmartmeterReadLog = (body) => {
    return axios.post('api/iot/smartmeter/readLog', body)
}

// 水电充值开通、关闭预付
export const orderRechargePrepaid = (id) => {
    return axios.post('api/order/recharge/prepaid', { id })
}

// 水电充值手工充值
export const orderRechargeAdd = (body) => {
    return axios.post('api/assembly/order/recharge/add', body)
}

// 水电充值余额
export const houseWeFee = (houseId) => {
    return axios.post('api/assets/house/houseWeFee', { houseId })
}

/**
 * 生成订单-H5
 * @param body
 */
export const orderInfoGen = (body) => {
    return axios.post('api/order/info/unifiedOrder', body)
}
/**
 * 支付订单-H5
 * @param body
 */
export const orderInfoPay = (body) => {
    return axios.post('api/order/info/pay', body)
}
// 统一下单
export const unifiedOrder = (body) => {
    return axios.post('api/pay/unifiedOrder', body)
}
// 订单查询, 测试demo用
export const queryOrder = (body) => {
    return axios.post('api/pay/queryOrder', body)
}

// 计算金额
export const calcPayAmount = (body) => {
    return axios.post('api/order/info/calcPayAmount', body)
}

// 提交转账确认
export const submitConfirm = (body) => {
    return axios.post('api/order/info/submitConfirm', body)
}

// 线下支付,保存凭证
export const offlinePayPic = (body) => {
    return axios.post('api/order/info/offlinePayPic', body)
}

// zxx:20210811:查询水电流水列表
export const getWeFlowList = (body) => {
    return axios.post('/api/finance/weflow/list', body)
}
